import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AdminGallery = ({ token }) => {
  const [images, setImages] = useState([]);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const navigate = useNavigate();

  // common functions
  const showMessageWithType = (type, msg) => {
    setMessageType(type);
    setMessage(msg);
    setShowMessage(true);
  };

  useEffect(() => {
    if (showMessage) {
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, 5000); // Display message for 3 seconds
      return () => clearTimeout(timer); // Clear timeout if component unmounts
    }
  }, [showMessage]);

  //----------------
  useEffect(() => {
    // Check if the token is present and valid
    const checkToken = () => {
      if (!token) {
        showMessageWithType(
          "error",
          "You need to be logged in to access this page."
        );
        navigate("/adminlogin"); // Redirect to login if no token
        return;
      }

      // Optionally check token validity (e.g., decode and check expiration)
      try {
        const { exp } = JSON.parse(atob(token.split(".")[1])); // Decode JWT payload
        if (exp * 1000 < Date.now()) {
          // Token is expired
          showMessageWithType(
            "error",
            "Your session has expired. Please log in again."
          );
          navigate("/adminlogin");
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        showMessageWithType(
          "error",
          "An error occurred while validating your session. Please log in again."
        );
        navigate("/adminlogin");
      }
    };

    checkToken();
  }, [token, navigate]);
  //common function ends

  useEffect(() => {
    // Fetch uploaded images from the server
    const fetchImages = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/images`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setImages(response.data.images); // Adjust based on your API response
      } catch (err) {
        console.error("Error fetching images:", err);
        setMessageType("error");
        setMessage("Failed to load images. Please try again.");
      }
    };

    fetchImages();
  }, [token]); // Re-fetch images whenever the token changes

  const handleDelete = async (imageName) => {
    console.log("imageName : ", imageName);
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/delete-image/${imageName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Remove the deleted image from the list
      setImages(images.filter((img) => img.imagename !== imageName));

      showMessageWithType("error", "Image deleted successfully");
    } catch (err) {
      console.error("Error deleting image:", err);
      showMessageWithType("error", "Failed to delete image. Please try again.");
    }
  };

  return (
    <div className="container">
      <div className="gallery-container">
        {showMessage && (
          <p className={`${messageType} ${!showMessage && "hidden"}`}>
            {message}
          </p>
        )}
        <h6 className="divider-full-width">Uploaded Images</h6>
        <div className="gallery-grid">
          {images.map((image) => (
            <div key={image.imagename} className="gallery-item">
              <img
                src={image.imageurl}
                alt={image.imagename}
                className="gallery-image"
              />{" "}
              {/* Adjust based on your image data structure */}
              <button
                onClick={() => {
                  if (window.confirm("Are you sure to delete this image?")) {
                    handleDelete(image.imagename);
                  }
                }}
                className="delete-button"
              >
                Delete
              </button>
            </div>
          ))}
        </div>
        <div className="divider-full-width"></div>
      </div>
    </div>
  );
};

export default AdminGallery;
